
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({

  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      abc: ''
    }
  },
  computed: {
    ...mapGetters(['getVesselMonitoringType']),
    getLoadedWrongPositionNotMatchedFieldsItems() {
      const raw = this.data?.loadedWrongPositionNotMatchedFields;
      if (!raw) return [];
      return raw.split(',').map(item => item.trim()).filter(item => item !== '');
    }
  },
  methods: {
    // متد جدید برای بررسی اینکه آیا آیتم در لیست وجود دارد یا خیر
    hasWrongPositionField(fieldName: string) {
      return this.getLoadedWrongPositionNotMatchedFieldsItems?.includes(fieldName);
    },
    getCellBackgroundColor() {
      const shouldChangeColor = 
        this.getVesselMonitoringType == 'Load' && 
        this.data.operationIsDone && 
        this.hasWrongPositionField('PortOfDischarge');
      
      return shouldChangeColor ? '#999999' : `#${this.data.fill}`;
    },
    
  }
  


})
